import {handleGqlResponseBody} from '@/utils/apollo.util';
import {GET_PRODUCT_PAGINATED_QUERY} from '@/graphql/product/product.query';
import {GET_PRICE_POLICY_PAGINATED_QUERY} from '@/graphql/price-policy/price-policy.query';
import {GET_PRODUCT_REVIEW_PAGINATED_QUERY} from '@/graphql/product/review/review.query';
import {GET_PRODUCT_REVIEW_REPLY_PAGINATED_QUERY} from '@/graphql/product/review/reply.query';

const product = {
	actions: {
		async getProductsPaginatedQuery({commit}, {skip, take, orderBy, search, showInShop, currency}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						search,
						showInShop,
						currency
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getPricePolicyPaginatedQuery({commit}, {skip, take, orderBy}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRICE_POLICY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductReviewsPaginatedQuery({commit}, {skip, take, orderBy, query}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_REVIEW_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductReviewRepliesPaginatedQuery({commit}, {skip, take, orderBy, reviewId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_REVIEW_REPLY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						reviewId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
	}
};

export default product;
